import React from 'react';
// import { Tabs, Tab } from '@cityelectricalfactors/ui-components';

import QuickOrdersForm from './manual_entry';
// import CopyPasteForm from './copy_paste';
// import UploadListForm from './upload_list';

const QuickOrders = ({ /* icons */ vatStatus }) => {
  // const { manualEntry } = icons;
  // const [copyPasteTextArea, setCopyPasteTextarea] = useState([]);

  return (
    <QuickOrdersForm vatStatus={vatStatus} />

    // <Tabs>
    //   <Tab id="tabOne" name="Manual Entry" icon={manualEntry}>
    //   </Tab>
    //   <Tab id="tabTwo" name="Copy & Paste" icon={copyPaste}>
    //     <CopyPasteForm
    //       copyPasteTextArea={copyPasteTextArea}
    //       setCopyPasteTextarea={setCopyPasteTextarea}
    //     />
    //   </Tab>
    //   <Tab id="tabThree" name="Upload a List" icon={uploadList}>
    //     <UploadListForm />
    //   </Tab>
    // </Tabs>
  );
};

export default QuickOrders;
